import type {
  ApprovedItem,
  ApproveRecommendationsInput,
  ApproveRecommendationsResult,
  AutomatedSkillPathsFilter,
  GenerateRecommendationsInput,
  GenerateRecommendationsResult,
  Recommendation
} from '../types';

import {mockApi} from './mockApi';

/**
 * Everything the Automated Skill Paths flow needs from the backend. The UI depends on this and
 * nothing else, so swapping the mock for GraphQL touches only this file.
 */
export interface AutomatedSkillPathsApi {
  /**
   * Runs the policy for every student who completed the diagnostics: a skill below Intermediate
   * comes back as weak (WEAK) with its prerequisites (BUILDS_TOWARD); a proven skill brings the
   * next skill up (BUILDS_ON) and a related one (RELATES_TO). Replaces those students' outstanding
   * recommendations; approved items are untouched until approve.
   */
  generateRecommendations: (
    input: GenerateRecommendationsInput
  ) => Promise<GenerateRecommendationsResult>;
  /**
   * Outstanding recommendations in scope, one per student and skill, each with its reasons
   * strongest first and the diagnostics its generation ran on.
   */
  recommendedSkills: (filter: AutomatedSkillPathsFilter) => Promise<Recommendation[]>;
  /** How many outstanding recommendations are in scope, under the same scope rules. */
  recommendedSkillsCount: (filter: AutomatedSkillPathsFilter) => Promise<number>;
  /**
   * Turns `recommendationIds` into skill path items whose dates the backend sets, spaced per
   * student in path order. Each approved student's unfulfilled Albert-added items in the same subject
   * are retired first; fulfilled items stay. Records `dismissedIds` as removals. Both leave the
   * outstanding list.
   */
  approveRecommendations: (
    input: ApproveRecommendationsInput
  ) => Promise<ApproveRecommendationsResult>;
  approvedSkills: (filter: AutomatedSkillPathsFilter) => Promise<ApprovedItem[]>;
}

export const automatedSkillPathsApi: AutomatedSkillPathsApi = mockApi;
